import XMLIcon from './component'

export default XMLIcon
